/**
* 購入情報管理
*/
const actions = {
  /**
   * step管理
   */
  setStep({ commit }, step) {
    if (!step) return;
    commit('setStep', step);
  },
  setAddressData({ commit }, data) {
    commit('setAddressData', data);
  },
  setShippingMethodData({ commit }, data) {
    commit('setShippingMethodData', data);
  },
  setPaymentMethodData({ commit }, data) {
    commit('setPaymentMethodData', data);
  },
  reset({ commit }) {
    commit('setStep', 1);
    commit('setAddressData', {});
    commit('setShippingMethodData', {});
    commit('setPaymentMethodData', null);
  },
};

const mutations = {
  setStep(state, step) {
    state.step = step;
  },
  setAddressData(state, data) {
    state.addressData = data;
  },
  setShippingMethodData(state, data) {
    state.shippingMethodData = data;
  },
  setPaymentMethodData(state, data) {
    state.paymentMethodData = data;
  },
};

const state = {
  step: 1,
  addressData: {},
  shippingMethodData: {},
  paymentMethodData: null,
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
